import type { ReactNode } from "react";
import type { AssuranceMode } from "@veto/domain";
import type { ProfileMedia } from "@veto/protocol";
import { Onboarding } from "../screens/Onboarding";
import { LockScreen } from "../screens/LockScreen";

type Screen = "loading" | "onboarding" | "lock" | "app" | "error";

export function AppGate({
  screen,
  onCompleteOnboarding,
  onUnlock,
  children,
}: {
  screen: Screen;
  onCompleteOnboarding: (input: {
    displayName: string;
    pin: string;
    assuranceMode: AssuranceMode;
    avatar?: ProfileMedia | null;
  }) => Promise<void>;
  onUnlock: (pin: string) => Promise<void>;
  children: ReactNode;
}) {
  if (screen === "loading") {
    return (
      <div className="loading-screen">
        <div className="loading-mark">V</div>
      </div>
    );
  }
  if (screen === "error") {
    return (
      <div className="onboarding">
        <div className="card stack" role="alert">
          <h2>Veto couldn&apos;t start</h2>
          <p className="muted">
            Your encrypted data is safe, but secure storage didn&apos;t open. This usually happens when Veto
            is open in another tab or window that is updating — close the other tabs and try again.
          </p>
          <button className="btn" type="button" onClick={() => window.location.reload()}>
            Try again
          </button>
        </div>
      </div>
    );
  }
  if (screen === "onboarding") return <Onboarding onComplete={onCompleteOnboarding} />;
  if (screen === "lock") return <LockScreen onUnlock={onUnlock} />;
  return <>{children}</>;
}
